import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { ENV } from './constants/env.ts';

Sentry.init({
  dsn: ENV.VITE_SENTRY_DSN,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration({
      maskAllText: ENV.PROD, 
      blockAllMedia: false, 
      networkDetailAllowUrls: [window.location.origin],
      networkCaptureBodies: true,
      maskAllInputs: false,
    }),
  ],
  environment: ENV.MODE,
  beforeSend(event) {
    // Add global tags
    event.tags = {
      ...event.tags,
      buildMode: ENV.MODE,
      isDev: ENV.DEV,
    };

    // Add additional context
    event.contexts = {
      ...event.contexts,
      app: {
        version: ENV.VITE_APP_VERSION || 'unknown',
      }
    };

    return event;
  },
  replaysSessionSampleRate: 1, // This sets the sample rate at 100%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});



ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
